import { Link } from "react-router-dom";
import { Phone, ArrowRight, Gem } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useT } from "@/i18n";

const COACH_CALL_URL = "https://www.my-within.com/coach-call/";
const FOUNDER_URL = "https://www.my-within.com/founder-500/";

export function AnnouncementBar() {
  const { isAuthed } = useAuth();
  const t = useT();

  return (
    <div className="bg-primary text-primary-foreground" data-testid="announcement-bar">
      <div className="container-page flex flex-wrap items-center justify-center gap-x-5 gap-y-1 py-2 text-center text-xs sm:text-sm">
        <a
          href={COACH_CALL_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="announce-coach-call"
          className="inline-flex items-center gap-1.5 font-medium underline-offset-2 hover:underline"
        >
          <Phone className="h-3.5 w-3.5" />
          {t("announce.coach_call")}
          <ArrowRight className="h-3.5 w-3.5" />
        </a>
        <span className="hidden text-primary-foreground/50 sm:inline">·</span>
        <a
          href={FOUNDER_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="announce-founder"
          className="inline-flex items-center gap-1.5 font-medium underline-offset-2 hover:underline"
        >
          <Gem className="h-3.5 w-3.5" />
          {t("announce.founder")}
          <ArrowRight className="h-3.5 w-3.5" />
        </a>
        {!isAuthed && (
          <>
            <span className="hidden text-primary-foreground/50 sm:inline">·</span>
            <Link
              to="/signup"
              data-testid="announce-free-signup"
              className="inline-flex items-center gap-1.5 font-medium underline-offset-2 hover:underline"
            >
              {t("announce.free_signup")}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
